import { byFilterKey } from './pageConfig/Predicates/SelectedFiltersPredicates';
import { FilterKeys, Filters, PageName } from './pageConfig/Types';

const formatMessageForTotalAvailablePgs = (totalPgsAvailable: number, totalSubscribedPgs: number): string => {
  return `${totalPgsAvailable.toString()} product ${
    totalPgsAvailable > 1 ? 'categories' : 'category'
  } out of ${totalSubscribedPgs.toString()}`;
};

export const getProductGroupInfo = (
  appliedFilters: Filters[],
  totalPgsAvailable: number,
  totalSubscribedPgs: number,
): string => {
  const appliedProductGroups = appliedFilters.find(byFilterKey(FilterKeys.PRODUCT_GROUP));
  if (!appliedProductGroups) {
    if (totalPgsAvailable !== totalSubscribedPgs) {
      return formatMessageForTotalAvailablePgs(totalPgsAvailable, totalSubscribedPgs);
    }
    return 'all your subscribed product categories';
  }

  if (appliedProductGroups.options.length > 1) {
    if (totalPgsAvailable !== totalSubscribedPgs) {
      return formatMessageForTotalAvailablePgs(totalPgsAvailable, totalSubscribedPgs);
    }
    return 'multiple categories';
  }

  return appliedProductGroups.options[0].label;
};

export const getCountriesInfo = (appliedFilters: Filters[]): string => {
  const appliedCountries = appliedFilters.find(byFilterKey(FilterKeys.COUNTRY));
  if (appliedCountries) {
    return appliedCountries.options.length > 1 ? 'multiple countries' : appliedCountries.options[0].label;
  }
  return '';
};

export const getAppliedPgAndCountriesInfo = (
  appliedFilters: Filters[],
  totalPgsAvailable: number,
  totalSubscribedPgs: number,
  pageName?: PageName,
) => {
  const productGroupInfo = getProductGroupInfo(appliedFilters, totalPgsAvailable, totalSubscribedPgs);
  const countriesInfo = getCountriesInfo(appliedFilters);

  switch (pageName) {
    case PageName.RETAILER_OVERVIEW:
      return `of ${productGroupInfo} in ${countriesInfo}`;
    case PageName.TRADING_ASSISTANT:
      return `You are looking at ${productGroupInfo} in ${countriesInfo}`;
    case PageName.EXPLORE:
    default:
      return `You are viewing data for ${productGroupInfo} in ${countriesInfo}`;
  }
};
